module.exports = __webpack_public_path__ + "static/media/control-points-pic3.d33ec67d.svg";